import { useQuery } from "react-query";
import { fetchCommandExports } from "../queries/command_exports.queries";

export const useCommandExports = () => {
	const res = useQuery(["commands", "exports"], () => {
		try {
			return fetchCommandExports();
		} catch (err) {
			return null;
		}
	});
	const commands = res.data;

	return { commands };
};
